import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IconButtonComponent, IconComponent } from '../../../base';
import { DialogDirective } from '../../directives/dialog.directive';
import { DialogData } from '../../model';
import { DialogActionComponent } from '../dialog-action/dialog-action.component';

import * as deTranslations from '../../i18n/de-lang.json';
import * as enTranslations from '../../i18n/en-lang.json';

@Component({
  selector: 'spx-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  imports: [
    CommonModule,
    MatProgressBarModule,
    FlexLayoutModule,
    TranslateModule,
    IconComponent,
    IconButtonComponent,
    DialogActionComponent,
    MatDividerModule,
    MatDialogModule,
    DialogDirective,
  ],
})
export class DialogComponent<T> implements OnInit {
  /**
   * Loading state of dialog component
   */
  public loading = false;

  /**
   * Dialog Directive for dynamic content projection
   */
  @ViewChild(DialogDirective, { static: true }) dialogDirective!: DialogDirective;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent<T>>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData<T>,
    private translate: TranslateService,
  ) {
    this.translate.setTranslation('en', enTranslations, true);
    this.translate.setTranslation('de', deTranslations, true);
  }

  ngOnInit() {
    // if the component is set in the data, dynamically insert it at the ng-content of the dialog directive
    if (this.data.component) {
      const viewContainerRef = this.dialogDirective.viewContainerRef;
      viewContainerRef.clear();

      viewContainerRef.createComponent(this.data.component);
    }
  }

  /**
   * Sets the loading state of the dialog
   * @param loading
   */
  public setLoading(loading: boolean): void {
    this.loading = loading;
  }

  /**
   * Closes the dialog
   */
  public closeDialog(): void {
    this.dialogRef.close();
  }
}
